import { resourceReducer, getResources } from 'redux-resource';
import metaReducer from './metaReducer';

const rollingArrangements = resourceReducer('rollingArrangements', {
  plugins: [metaReducer],
});

export default rollingArrangements;

export const getRollingArrangement = (state, rollingArrangementId) =>
  getResources(state, [rollingArrangementId])[0];
export const getRollingArrangements = (state, page = 1) =>
  getResources(state, `rollingArrangements${page}`);
export const getUserRollingArrangements = (state, page = 1) =>
  getResources(state, `userRollingArrangements${page}`);
